import { IAccountDocument } from '@epicuro-next/data/documents';
import { createAction, props } from '@ngrx/store';

export const loadUserAgreement = createAction('[User] Load user agreement');

export const loadUserAgreementSuccess = createAction(
  '[User] Load user agreement success',
  props<{ documents: ReadonlyArray<IAccountDocument> }>(),
);

export const loadUserAgreementFailure = createAction(
  '[User] Load user agreement failure',
);
